module.exports = __webpack_public_path__ + "static/media/dark-preview.0fa9de07.svg";